import { ReactNode } from 'react'

type Props = {
    children: ReactNode
}

const PageContent = ({ children }: Props) => {
    return <div className='w-[95%] xl:w-[90%] mx-auto my-4'>{children}</div>
}

export default PageContent
